import PriceSimulator from "@/components/sections/PriceSimulator";
import { useSEO } from "@/lib/hooks";

export default function SimulatorPage() {
  useSEO({
    title: "Simulateur de prix — Depann7",
    description: "Estimez instantanément le prix de votre dépannage ou remorquage en Île-de-France selon distance, urgence et conditions.",
  });
  return (
    <div className="bg-white">
      <div className="bg-ink-900 text-white py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-6">
          <h1 className="text-3xl lg:text-4xl font-extrabold">Simulateur de prix</h1>
          <p className="text-ink-300 mt-2 max-w-2xl">Estimation gratuite et instantanée. Le tarif final est confirmé par téléphone.</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 lg:px-6 py-12">
        <div className="bg-white border border-surface-200 rounded-2xl shadow-card overflow-hidden"><PriceSimulator /></div>
      </div>
    </div>
  );
}
